import { Button } from "@mui/material";
import Image from "next/image";
import styles from "./AvailableHomesFilters.module.scss";

export type AvailableHomesFiltersEmptyProps = {
  onClearFilters: () => void;
};

export const AvailableHomesFiltersEmpty: React.FC<AvailableHomesFiltersEmptyProps> = ({ onClearFilters }) => {
  return (
    <div className={styles.emptyStateContainer}>
      <div className={styles.emptyStateContent}>
        <div className={styles.emptyStateBanner}>
          <div className={styles.emptyStateTitleContainer}>
            <Image
              className={styles.emptyStateIcon}
              src="/image/icon_floorplans_matches.svg"
              width={24}
              height={24}
              alt="Floorplans Matches"
            />
            <span className={styles.emptyStateTitle}>Units Available</span>
          </div>
          <span className={styles.emptyStateSubtitle}>Your filters are preventing you from seeing all units</span>
        </div>
        <Button
          className={styles.emptyStateButton}
          variant="outlined"
          color="primary"
          onClick={onClearFilters}
        >
          Clear Filters
        </Button>
      </div>
    </div>
  );
};
